// The Transfer to Support and escalation notes on the Messages tab's AI
// Suggestion panel (2026-10-09). They come from the CONTACT's newest event
// (GET /api/conversations/:id's latestTransfer / latestEscalation), not only
// from the suggestion they were recorded on: a regenerate or a new inbound
// turn makes a newer suggestion with no note, and on prod contact 5377188
// that hid the transfer note from the Support agent.
//
// Pure, so the rules are unit-testable:
// - the transfer block shows while the contact's effective team is Support;
// - the escalation block shows while the conversation status is 'escalated';
// - transfer first, then escalation; each event once, whichever suggestion
//   is current (the current suggestion's own fields stand in only when the
//   contact has no event, e.g. a server from before this change).
// Informational only: nothing here changes what can be sent or processed.

function fromSuggestionTransfer(s) {
  return s?.transferredAt || s?.transferredBy
    ? { suggestionId: s.id ?? null, by: s.transferredBy ?? null, at: s.transferredAt ?? null, note: s.transferNote ?? null }
    : null
}

function fromSuggestionEscalation(s) {
  return s?.status === 'escalated' || s?.escalatedAt
    ? { suggestionId: s.id ?? null, by: s.escalatedBy ?? s.decidedBy ?? null, at: s.escalatedAt ?? s.decidedAt ?? null, note: s.escalationNote ?? null }
    : null
}

export function contactNoteBlocks({ latestTransfer = null, latestEscalation = null, team = null, conversationStatus = null, suggestion = null } = {}) {
  const blocks = []
  const transfer = latestTransfer ?? fromSuggestionTransfer(suggestion)
  if (transfer && team === 'support') blocks.push({ kind: 'transfer', ...transfer })
  const escalation = latestEscalation ?? fromSuggestionEscalation(suggestion)
  if (escalation && conversationStatus === 'escalated') blocks.push({ kind: 'escalation', ...escalation })
  return blocks
}

// "Transferred to Support by Ana · 10/9/2026, 9:14:03 AM" / "Escalated by Bo · …".
export function contactNoteHeading(block, formatDate = (iso) => new Date(iso).toLocaleString()) {
  const verb = block.kind === 'transfer' ? 'Transferred to Support' : 'Escalated'
  const by = block.by ? ` by ${block.by}` : ''
  const at = block.at ? ` · ${formatDate(block.at)}` : ''
  return `${verb}${by}${at}`
}
